/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addTooltip: "Add to columns",
    allTooltip: "Show all columns",
    bottomTooltip: "At bottom",
    clearTooltip: "Show no columns",
    columnsLabel: {
        nonVisibleColumn: "Available columns",
        visibleColumn: "Selected columns"
    },
    configurationName: "Name",
    downTooltip: "Move down",
    emptyTitle: "Column list cannot be empty",
    emptyWarning: "Configuration has been restored",
    removeTooltip: "Remove from columns",
    resetTooltip: "Show default columns",
    topTooltip: "On top",
    upTooltip: "Move up"
};